(function () {
  'use strict';

  var generation = 0;
  var reloading = false;

  function resultKey() {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.searchParams.sort();
    return url.pathname + '?' + url.searchParams.toString();
  }

  function stopLoader() {
    var loader = window.gsscroller;

    if (loader) {
      document.removeEventListener('scroll', loader.analyseView);
      window.removeEventListener('resize', loader.analyseView);
      window.removeEventListener('orientationchange', loader.analyseView);
    }

    if (window.httpRequest && window.httpRequest.readyState !== 4) {
      window.httpRequest.onreadystatechange = null;
      window.httpRequest.abort();
    }
  }

  function resetLoader() {
    var loader = window.gsscroller;
    var section = document.querySelector('[data-section-type="collection"]');
    var products = section && section.querySelector('.CollectionInner__Products');
    var grid = products && products.querySelector('.ProductList--grid');
    var pagination = products && products.querySelector('.Pagination__Nav');

    if (!loader || !grid || !pagination) {
      return;
    }

    loader.containerElement = grid;
    loader.paginateSection = pagination;
    window.paginateSel = pagination;
    window.productsParentTmp = window.jQInf(grid);
    window.collectionPageNr = Number(new URL(window.location.href).searchParams.get('page')) || 1;
    window.collectionParent = '.CollectionInner__Products .ProductList--grid';
    window.paginateSelector = '.CollectionInner__Products .Pagination__Nav';
    window.containerPos = 1;

    var sentinel = products.querySelector('#gscollectionbottom');

    if (!sentinel) {
      sentinel = document.createElement('div');
      sentinel.id = 'gscollectionbottom';
      sentinel.style.cssText = 'width:100%;float:none;';
      var center = document.createElement('center');
      var spinner = document.createElement('img');
      spinner.src = 'https://gravity-apps.com/variantmanager/media/spin.gif';
      spinner.style.marginTop = '10px';
      center.appendChild(spinner);
      sentinel.appendChild(center);
      products.querySelector('.Pagination').appendChild(sentinel);
    }

    pagination.style.display = 'none';
    loader.listenToScroll();
  }

  function install() {
    if (!window.GSLoader || !window.GSLoader.prototype.fetchNextPage) {
      return false;
    }

    var prototype = window.GSLoader.prototype;

    if (prototype.nappaFiltersPreserved) {
      return true;
    }

    var fetchNextPage = prototype.fetchNextPage;
    prototype.fetchNextPage = function () {
      if (reloading || !this.containerElement || !this.containerElement.isConnected) {
        return;
      }

      var requested = new URL(this.nextStepLink, window.location.origin);
      var current = new URL(window.location.href);

      // The app drops filter.* while constructing its next link. Keep the full
      // active collection query and change only the requested page number.
      current.searchParams.set('page', requested.searchParams.get('page'));
      current.searchParams.delete('section_id');
      this.nextStepLink = current.toString();

      var requestGeneration = generation;
      var requestKey = resultKey();
      var container = this.containerElement;
      fetchNextPage.call(this);

      var request = window.httpRequest;
      var ready = request && request.onreadystatechange;

      if (typeof ready === 'function') {
        request.onreadystatechange = function () {
          if (requestGeneration === generation && requestKey === resultKey() && container.isConnected && !reloading) {
            ready.apply(this, arguments);
          }
        };
      }
    };

    prototype.nappaFiltersPreserved = true;
    return true;
  }

  document.addEventListener('collection:reload:start', function () {
    generation += 1;
    reloading = true;
    stopLoader();
  });

  document.addEventListener('collection:reload:end', function () {
    reloading = false;
    if (install()) {
      resetLoader();
    }
  });

  if (!install()) {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (install() || attempts >= 300) {
        window.clearInterval(timer);
      }
    }, 100);
  }
})();
